import Combobox from 'react-widgets/lib/Combobox';
import { Col, Row } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
const isEmpty = require('is-empty');

class SocialReasonModal extends Component {

    state = {
        isValidInnerBranchId:    false,
        isValidListaPrecioMB:    false,
        isValidNumeroMyBusiness: false,
        isValidNumeroSap:        false,
        numeroMyBusiness:        '',
		innerBranchId:           '',
		listaPrecioMB:           '',
        numeroSap:               '',
		errorInnerBranchId:      '',
		errorListaPrecioMB:      '',
        errorNumeroMyBusiness:   '',
        errorNumeroSap:          '',
        statusData:              ''
    }

    constructor(props) {
		super(props);
        this.deleteSocialReason = this.deleteSocialReason.bind(this);
        this.preparateUpdate    = this.preparateUpdate.bind(this);
        this.sendDataCreate     = this.sendDataCreate.bind(this);
        this.onPressCancel      = this.onPressCancel.bind(this);
		this.onPressEsc         = this.onPressEsc.bind(this);
		document.addEventListener('keydown', this.onPressEsc, false);
	}

    componentDidMount() {
        if (this.props.type === 'UPDATE') {
            let statusData = {
                label:  this.props.socialReasonData.status,
                status: this.props.socialReasonData.status
            };
            if (this.props.socialReasonData.status === 'SYNCING') {
                statusData.label = 'Por sincronizar';
            } else if (this.props.socialReasonData.status === 'SYNCRONIZED') {
                statusData.label = 'Sincronizado';
            } else if (this.props.socialReasonData.status === 'DATA_NOT_FOUND') {
                statusData.label = 'Sin datos en POS';
            }
            this.setState({
                innerBranchId:  this.props.socialReasonData.innerBranchId !== null ? this.props.socialReasonData.innerBranchId : '',
                listaPrecioMB:  this.props.socialReasonData.listaPrecioMB !== null ? this.props.socialReasonData.listaPrecioMB : '',
                statusData:     statusData
            });
        }
    }

    ///---------------------------------------EVENTS-------------------------------------
    
    onPressEsc(event) {
        if (event.keyCode === 27) {
            this.onPressCancel();
		}
	}
    
    onPressCancel() {
        this.props.onPressCancel();
    }

    async preparateUpdate() {
        await this.clearErrorsUpdate();
		this.validateUpdate();
		if (this.state.isValidInnerBranchId && this.state.isValidListaPrecioMB) {
            const data = {
                id:            this.props.socialReasonData._id,
                listaPrecioMB: this.state.listaPrecioMB,
                innerBranchId: this.state.innerBranchId,
            };
            this.cleanFormUpdate();
            this.props.updateSocialReason(
                data
            );
        }
    }
            
    async sendDataCreate() {
        await this.clearErrorsCreate();
        this.validateCreate();
        if (this.state.isValidInnerBranchId && this.state.isValidNumeroMyBusiness && this.state.isValidNumeroSap) {
            const data = {
                numeroMyBusiness: this.state.numeroMyBusiness,
                numeroSap:        this.state.numeroSap,
                innerBranchId:    this.state.innerBranchId
            };
            this.cleanFormCreate();
            this.props.createSocialReason(data);
        }
	}


    deleteSocialReason() {
		this.props.deleteSocialReason(this.props.socialReasonData._id);
	}

    clearErrorsUpdate = () => {
		this.setState({
            errorInnerBranchId:   '',
            errorListaPrecioMB:    '',
		})
	}

    clearErrorsCreate = () => {
		this.setState({
            errorInnerBranchId:    '',
            errorNumeroMyBusiness: '',
            errorNumeroSap:        ''
		})
	}

    cleanFormUpdate() {
		this.setState({
			listaPrecioMB: '',
            innerBranchId: '',
		});
	}

    cleanFormCreate() {
		this.setState({
            innerBranchId:    '',
            numeroMyBusiness: '',
            numeroSap:        ''
		});
	}

    validateUpdate() {
        this.setState({
            isValidInnerBranchId: (this.state.innerBranchId === '' && isEmpty(this.state.innerBranchId)) ? false : true,
            isValidListaPrecioMB: (this.state.listaPrecioMB === '' && isEmpty(this.state.listaPrecioMB)) ? false : true,
            errorInnerBranchId:   this.state.innerBranchId  ? '' : 'El InnerBranch Id es requerido',
            errorListaPrecioMB:   this.state.listaPrecioMB  ? '' : 'La lista de precios MB es requerida', 
        });
    }

    validateCreate() {
        if (!this.state.numeroMyBusiness) {
            this.setState({
                isValidNumeroMyBusiness: false
            });
		} else {
			let regexPruebas    = new RegExp("^SYS*$");
            let regexMyBusiness = new RegExp("^([0-9])*$");
			if (
                (this.state.numeroMyBusiness.length === 3 && this.isValidRegExp(regexPruebas, this.state.numeroMyBusiness)) ||
                (this.state.numeroMyBusiness.length === 8 && this.isValidRegExp(regexMyBusiness, this.state.numeroMyBusiness))
            ) {
                this.setState({
                    isValidNumeroMyBusiness: true
                });
			} else {
                this.setState({
                    isValidNumeroMyBusiness: false
                });
			}
		}

        if (!this.state.numeroSap) {
            this.setState({
                isValidNumeroSap: false,
            });
		} else {
			let regexPruebas = new RegExp("^F[0-9]*$");
            let regexSAP     = new RegExp("^0000[0-9]*$");
			if (
                (this.state.numeroSap.length === 4  && this.isValidRegExp(regexPruebas, this.state.numeroSap)) ||
                (this.state.numeroSap.length === 10 && this.isValidRegExp(regexSAP, this.state.numeroSap))
            ) {
                this.setState({
                    isValidNumeroSap: true
                });
			} else {
				this.setState({
                    isValidNumeroSap: false,
                });
			}
		}

        this.setState({
            isValidInnerBranchId:  (this.state.innerBranchId === '' && isEmpty(this.state.innerBranchId)) ? false : true,
            errorNumeroMyBusiness: this.state.isValidNumeroMyBusiness === false ? "Ingrese el campo My Businnes con un formato de 8 números o 'SYS' para pruebas": '',
            errorInnerBranchId:    this.state.innerBranchId  ? '' : 'El InnerBranch Id es requerido',
            errorNumeroSap:        this.state.isValidNumeroSap === false ? "Ingrese el campo SAP con un formato de 10 números o 'F000' para pruebas": '',
        });
    }

    onChangeInnerBranchId = (e) => {
		this.setState({
			innerBranchId:      e.innerBranchId,
            errorInnerBranchId: ''
		})
	}

    onChangeListaPrecioMB = (e) => {
		this.setState({
			listaPrecioMB:      e.target.value,
            errorListaPrecioMB: ''
		});
	}

    onChangeNumeroMyBusiness = (e) => {
		this.setState({
			numeroMyBusiness:      e.target.value,
            errorNumeroMyBusiness: ''
		});
	}

    onChangeNumeroSap = (e) => {
		this.setState({
			numeroSap:      e.target.value,
            errorNumeroSap: ''
		});
	}

    isValidRegExp(regex, value) {
		return regex.test(value);
	}

    ///---------------------------------------TEMPLATES-------------------------------------

    dataNotFound() {
		return (
			<>
                <div className="item">
                    No existen datos en POS, para el Número MB: {this.props.socialReasonData.usuarioMb} y Número SAP: {this.props.socialReasonData.usuarioSAP}
                </div>
			</>
		)
	}

	syncing() {
		return (
			<>
				<h2 className="bold2">
					Espere a que el proceso de Sincronización ejecute su tarea.
				</h2>
				<div className="item">
				    Número MB:{this.props.socialReasonData.usuarioMb} y Número SAP:{this.props.socialReasonData.usuarioSAP}
				</div>
			</>
		)
	}

	syncronized() {
		return (
			<>
				<div className="item">
					Después de la sincronización estos son los datos.
				</div>
				<div className="item">
					Razón social: '{this.props.socialReasonData.nombre}', RFC:{this.props.socialReasonData.rfc}
				</div>
			</>
		)
	}

    ///---------------------------------------VIEW-------------------------------------

    render() {
        const title = this.props.type === 'CREATE' ? 'CAPTURA LOS SIGUIENTES DATOS' : 'ACTUALIZACIÓN DE RAZÓN SOCIAL';
		return (
			<div className="modal display-block">
                <div className="modal-center-main">
                    <div className="auth-group" style={{ overflowY: 'auto', overflowX: 'hidden', width: '100%' }}>
                        <center>{title}</center>
                        <br />
                        { this.props.type === 'UPDATE' &&
                            <Row>
                                <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh' }}>
                                    <div className="item">
                                        <p>STATUS: {this.state.statusData.label}</p>
                                    </div>
                                    { this.state.statusData.status === 'DATA_NOT_FOUND' &&
                                        this.dataNotFound()
                                    }
                                    {
                                        this.state.statusData.status === 'SYNCING' &&
                                        this.syncing()
                                    }
                                    {
                                        this.state.statusData.status === 'SYNCRONIZED' &&
                                        this.syncronized()
                                    }
                                </Col>
                            </Row>
                        }
                        <div className="auth-label"></div>
                        <div className="auth-label"></div>
                        <form ref={(el) => { this.farmazonFormRef = el }}>
                            {
                                this.props.type !== 'UPDATE' && 
                                <>
                                    <Row>
                                        <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh' }}>
                                            <div className="auth-label" style={{width: '25%'}}>
                                                Número My Business
                                                <span className="required">*</span>
                                                <input
                                                    value={this.state.numeroMyBusiness}
                                                    error={this.state.errorNumeroMyBusiness}
                                                    type="text"
                                                    name="mb"
                                                    pattern="[0-9]*"
                                                    placeholder="Ej.:00011100"
                                                    className="local-store-input"
                                                    onChange={this.onChangeNumeroMyBusiness.bind(this)}
                                                />
                                            </div>
                                            <div className="auth-error">
                                                {this.state.errorNumeroMyBusiness}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh' }}>
                                            <div className="auth-label" style={{width: '25%'}}>
                                                Número SAP
                                                <span className="required">*</span>
                                                <input
                                                    value={this.state.numeroSap}
                                                    error={this.state.errorNumeroSap}
                                                    type="text"
                                                    name="sap"
                                                    placeholder="Ej.:0000112223"
                                                    pattern="[0-9]*"
                                                    className="local-store-input"
                                                    onChange={this.onChangeNumeroSap.bind(this)}
                                                />
                                            </div>
                                            <div className="auth-error">
                                                {this.state.errorNumeroSap}
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <Row>
                                <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh' }}>
                                <div className="auth-label" style={{width: '25%'}}>
                                    Centro Farmazon:
                                    <span className="required">*</span>
                                    <div className="row-multiselect-roles">
                                        <Combobox
                                            className="select-roles"
                                            data={this.props.centers}
                                            textField='nombre'
                                            valueField='innerBranchId'
                                            filter='contains'
                                            value= { this.state.innerBranchId }
                                            placeholder="Seleccione una opción"
                                            onChange={this.onChangeInnerBranchId.bind(this)}
                                        />
                                    </div>
                                </div>
                                <div className="auth-error">
                                    {this.state.errorInnerBranchId}
                                </div>
                                </Col>
                            </Row>
                            {
                                this.props.type === 'UPDATE' &&
                                <Row>
                                    <Col xs={12} md={12} sm={12} lg={12} style={{ marginTop: '1vh' }}>
                                        <div className="auth-label" style={{width: '25%'}}>
                                            Lista de precios MB:
                                            <span className="required">*</span>
                                            <input
                                                id="listaPrecioMBForm"
                                                ref={(el) => { this.listaPrecioMBForm = el }}
                                                onChange={this.onChangeListaPrecioMB.bind(this)}
                                                value={this.state.listaPrecioMB}
                                                error={this.state.errorListaPrecioMB}
                                                type="text"
                                                className="local-store-input"
                                                placeholder="Ej.: 1"
                                            />
                                        </div>
                                        <div className="auth-error">
                                            {this.state.errorListaPrecioMB}
                                        </div>
                                    </Col>
                                </Row>
                            }
                        </form>
                        <br/>
                        <div className="modal-activity-section">
                            { this.props.type !== 'UPDATE' && 
                                <button className="modal-buttonOK" onClick={this.sendDataCreate}>SINCRONIZAR</button>
                            }
                            { this.props.type === 'UPDATE' && 
                                <button className="modal-buttonOK" onClick={this.preparateUpdate}>ACTUALIZAR</button>
                            }
                            { this.props.type === 'UPDATE' && this.state.statusData.status === 'DATA_NOT_FOUND' &&
                                <button className="modal-buttonDeactivate" onClick={this.deleteSocialReason}>ELIMINAR</button>
                            }
							<button className="modal-buttonNo" onClick={this.onPressCancel}>CERRAR</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, 
)(SocialReasonModal);